// AIGuidelineApi.js
// API functions for AI Guideline / Scaffold documents

import { apiCall } from '../ApiUtils';

export const aiGuidelineApi = {
  // Get the AI guideline for a section (or root guideline if sectionId is null)
  async getGuideline(sectionId, classContext) {
    const query = sectionId ? `?sectionId=${sectionId}` : '';
    return await apiCall(`/document-editor/ai-guideline${query}`, { method: 'GET' }, classContext);
  },

  // Resolve the effective module (walking ancestor chain) and return policy_name + section_name
  async getEffectiveModule(sectionId, classContext) {
    if (!sectionId) return null;
    return await apiCall(
      `/document-editor/ai-guideline/effective-module?sectionId=${encodeURIComponent(sectionId)}`,
      { method: 'GET' },
      classContext
    );
  },

  // Save (create or update) the AI guideline for a section
  async saveGuideline(sectionId, title, content, classContext) {
    return await apiCall('/document-editor/ai-guideline', {
      method: 'POST',
      body: JSON.stringify({ sectionId: sectionId ?? null, title, content })
    }, classContext);
  },
};
